__turbopack_context__.v({
  "container": "mivZoG_container",
  "impact": "mivZoG_impact",
  "smartdistributionlabel": "mivZoG_smartdistributionlabel",
  "wrapper": "mivZoG_wrapper",
});
